// extracted by css-extract-rspack-plugin
export default {"root":"xNQDj8LXFfkc1j4S","text":"DgK3COVMrUv7vnls"};